import classNames from "classnames/dedupe";
import React, { ChangeEvent, FC, MouseEvent, TouchEvent } from "react";
import useWatchState from "../../../../../hooks/useWatchState";

export interface IProgressSliderProps {
  played?: number;
  onPointerStart?: () => void;
  onPointerEnd?: (value) => void;
  onChange?: (value) => void;
  classes?: {
    container?: string;
    slider?: string;
    progress?: string;
  };
}

const ProgressSlider: FC<IProgressSliderProps> = ({
  played,
  classes,
  onChange,
  onPointerStart,
  onPointerEnd,
}) => {
  const [playedState, setplayedState] = useWatchState({ value: played });

  const handlePointerStart = () => {
    onPointerStart && onPointerStart();
  };

  const handlePointerEnd = (
    event: MouseEvent<HTMLInputElement> | TouchEvent<HTMLInputElement>,
  ) => {
    setplayedState(+(event.target as HTMLInputElement).value);
    onPointerEnd && onPointerEnd((event.target as HTMLInputElement).value);
  };

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    setplayedState(+event.target.value);
    onChange && onChange(event.target.value);
  };

  const containerClass = classNames("product-video__seek", classes?.container);
  const sliderClass = classNames("product-video__slider", classes?.slider);
  const progressClass = classNames(
    "product-video__progress",
    classes?.progress,
  );

  return (
    <div className={containerClass}>
      <input
        className={sliderClass}
        type="range"
        min={0}
        max={0.999999}
        step="any"
        value={playedState}
        onMouseDown={handlePointerStart}
        onTouchStart={handlePointerStart}
        onChange={handleChange}
        onMouseUp={handlePointerEnd}
        onTouchEnd={handlePointerEnd}
        data-testid="slider-input"
      />
      <progress
        className={progressClass}
        max="1"
        value={playedState}
        data-testid="slider-progress"
      />
    </div>
  );
};

export default ProgressSlider;
